/* eslint-disable no-underscore-dangle */
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { transformData } from '../../common/picareUtil';

const PiCareLineChartUsage = () => {
  const { interactionStat, loading } = useSelector(
    (state) => state.picareDashboard,
  );
  const [viewType, setViewType] = useState('weekly');

  const rawData = useMemo(
    () =>
      interactionStat.map((item) => ({ date: item._id, count: item.count })),
    [interactionStat],
  );

  const processedData = useMemo(
    () => transformData(rawData, viewType),
    [rawData, viewType],
  );

  if (loading.interactionStat) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          padding: '8px 8px 8px 0px',
          justifyContent: 'space-between',
          alignItems: 'start',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            background: '#f1f5f9',
            padding: 4,
            borderRadius: 8,
            gap: 2,
          }}
        >
          {['weekly', 'monthly'].map((type) => (
            <button
              key={type}
              type="button"
              onClick={() => setViewType(type)}
              style={{
                padding: '6px 10px',
                fontSize: 11,
                fontWeight: 600,
                borderRadius: 6,
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.2s',
                background: viewType === type ? 'white' : 'transparent',
                color: viewType === type ? '#2563eb' : '#64748b',
                boxShadow:
                  viewType === type ? '0 1px 2px rgba(0,0,0,0.05)' : 'none',
                whiteSpace: 'nowrap',
                textAlign: 'left',
              }}
            >
              {type === 'weekly' ? '주간 합계' : '월간 합계'}
            </button>
          ))}
        </div>
        <div
          style={{ display: 'flex', alignItems: 'center', gap: 4, padding: 4 }}
        >
          <span
            style={{
              fontSize: 12,
              color: '#64748b',
              zIndex: 1,
              display: 'flex',
              alignItems: 'center',
              gap: 4,
            }}
          >
            <span
              style={{
                display: 'inline-block',
                width: 14,
                height: 2,
                background: '#0a2be8',
                borderRadius: 1,
                verticalAlign: 'middle',
              }}
            />
            사용 횟수
          </span>
        </div>
      </div>
      <div style={{ flex: 1, minWidth: 0, position: 'relative' }}>
        <div style={{ position: 'absolute', inset: 0 }}>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={processedData}>
              <defs>
                <linearGradient id="usageGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#0a2be8" stopOpacity={0.2} />
                  <stop offset="95%" stopColor="#0a2be8" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis
                dataKey="date"
                tick={{ fontSize: 12 }}
                interval={0}
                angle={-35}
                textAnchor="end"
                padding={{ left: 20, right: 30 }}
              />
              <YAxis width={30} tick={{ fontSize: 12 }} />
              <Tooltip cursor={{ fill: 'transparent' }} />
              <Area
                type="monotone"
                dataKey="count"
                name="사용 횟수"
                stroke="#0a2be8"
                fill="url(#usageGradient)"
                strokeWidth={2}
                dot={{ r: 4, fill: '#0a2be8' }}
                activeDot={{ r: 6 }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default PiCareLineChartUsage;
